import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, fromEvent, merge } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NetworkService {

  private isOnline$ = new BehaviorSubject<boolean>(navigator.onLine);
  private lastRoute: string | null = null;

  constructor(
    private router: Router,
    private ngZone: NgZone
  ) {}

  initNetworkListener() {
    this.ngZone.run(() => {
      merge(
        fromEvent(window, 'online'),
        fromEvent(window, 'offline')
      ).subscribe(() => {
        const online = navigator.onLine;
        this.isOnline$.next(online);

        if (!online) {
          this.handleOffline();
        } else {
          this.handleOnline();
        }
      });
    });
  }

  private handleOffline() {
    const currentUrl = this.router.url;

    if (currentUrl !== '/no-internet') {
      this.lastRoute = currentUrl;
    }

    this.router.navigate(['/no-internet'], { replaceUrl: true });
  }

  private handleOnline() {
    if (this.lastRoute) {
      this.router.navigateByUrl(this.lastRoute, { replaceUrl: true });
      this.lastRoute = null;
    }
  }

  getNetworkStatus() {
    return this.isOnline$.asObservable();
  }
}
